import {selPropGen} from 'module/Properties/selector/selPropGen'
import {PropID} from 'module/Properties/enum/PropID'
import {propDefaultFalse, propDefaultTrue} from 'module/Properties/util/PropertiesUtil'
import {createSelector} from 'reselect'
import {selUserConfigKeyGenerator} from 'module/UserConfig/selector/UserConfigSelector'
import {SisName} from 'util/SisName'
import {AppName, getAppName} from 'util/AppName'
import {UserConfigDefinitionType} from 'module/UserConfig/type/UserConfigType'

const appName = getAppName()

const TimelineConfigDict: UserConfigDefinitionType = {
	enabled: {
		label: 'Arbeitszeit',
		type: 'boolean',
		defaultValue: false,
		defaultOverrideSelector: selPropGen(PropID.stTagDefault, propDefaultFalse),
		visibleSelector: selPropGen(PropID.stTagVis, propDefaultTrue),
		userConfig: {
			DayModel_FullInfo: {
				label: 'Details anzeigen',
				type: 'boolean',
				defaultValue: false,
				defaultOverrideSelector: selPropGen(PropID.stTagDetailDefault, propDefaultFalse),
				visibleSelector: selPropGen(PropID.stTagDetailVis, propDefaultTrue),
			},
			DayModel_Show: {
				label: 'Tagesmodell anzeigen',
				type: 'boolean',
				defaultValue: true,
				defaultOverrideSelector: selPropGen(PropID.stTagModelDefault, propDefaultTrue),
				visibleSelector: selPropGen(PropID.stTagModelVis, propDefaultTrue),
				userConfig: {
					DayModel_EmptyColor: {
						/** @property DayModel_EmptyColor */
						label: "Farbe für Tage ohne Soll",
						defaultValue: '#a3a3a3',
						type: 'color',
						visibleSelector: selPropGen(PropID.stTagModelVis, propDefaultTrue),
					},
				},
			},
			WorkTime: {
				label: 'Zeiten',
				defaultValue: false,
				type: 'label',
				visibleSelector: createSelector(
					selPropGen(PropID.stTagNormalVis, propDefaultTrue),
					selPropGen(PropID.stTagKernVis, propDefaultTrue),
					selPropGen(PropID.stTagGlzVis, propDefaultTrue),
					(p1, p2, p3) => p1 || p2 || p3,
				),
				userConfig: {
					WorkTime_Normal: {
						/** @property WorkTime_Normal */
						label: 'Normalzeit',
						type: 'boolean',
						defaultValue: false,
						defaultOverrideSelector: selPropGen(PropID.stTagNormalDefault, propDefaultFalse),
						visibleSelector: selPropGen(PropID.stTagNormalVis, propDefaultTrue),
						userConfig: {
							WorkTime_NormalColor: {
								/** @property WorkTime_NormalColor */
								label: 'Farbe',
								type: 'color',
								defaultValue: '#0ABF37',
								visibleSelector: selPropGen(PropID.stTagNormalVis, propDefaultTrue),
								disabledSelector: selUserConfigKeyGenerator(SisName.StTagZu, "WorkTime_NormalColorFromModel"),
							},
							WorkTime_NormalColorFromModel: {
								/** @property WorkTime_NormalColor */
								label: 'Farbe aus Modell übernehmen',
								type: 'boolean',
								defaultValue: false,
								visibleSelector: selPropGen(PropID.stTagNormalVis, propDefaultTrue),
							},
						},
					},
					WorkTime_Kern: {
						/** @property WorkTime_Kern */
						label: 'Kernzeit',
						type: 'boolean',
						defaultValue: false,
						defaultOverrideSelector: selPropGen(PropID.stTagKernDefault, propDefaultFalse),
						visibleSelector: selPropGen(PropID.stTagKernVis, propDefaultTrue),
						userConfig: {
							WorkTime_KernColor: {
								/** @property WorkTime_KernColor */
								label: 'Farbe',
								type: 'color',
								defaultValue: '#EC3C1E',
								visibleSelector: selPropGen(PropID.stTagKernVis, propDefaultTrue),
								disabledSelector: selUserConfigKeyGenerator(SisName.StTagZu, "WorkTime_KernColorFromModel"),
							},
							WorkTime_KernColorFromModel: {
								/** @property WorkTime_KernColorFromModel */
								label: 'Farbe aus Modell übernehmen',
								type: 'boolean',
								defaultValue: false,
								visibleSelector: selPropGen(PropID.stTagKernVis, propDefaultTrue),
							},
						},
					},
					WorkTime_Glz: {
						/** @property WorkTime_Glz */
						label: 'Gleitzeit',
						type: 'boolean',
						defaultValue: false,
						defaultOverrideSelector: selPropGen(PropID.stTagGlzDefault, propDefaultFalse),
						visibleSelector: selPropGen(PropID.stTagGlzVis, propDefaultTrue),
						userConfig: {
							WorkTime_GlzColor: {
								/** @property WorkTime_GlzColor */
								label: 'Farbe',
								type: 'color',
								defaultValue: '#4562D9',
								visibleSelector: selPropGen(PropID.stTagGlzVis, propDefaultTrue),
								disabledSelector: selUserConfigKeyGenerator(SisName.StTagZu, "WorkTime_GlzColorFromModel"),
							},
							WorkTime_GlzColorFromModel: {
								/** @property WorkTime_GlzColorFromModel */
								label: 'Farbe aus Modell übernehmen',
								type: 'boolean',
								defaultValue: false,
								visibleSelector: selPropGen(PropID.stTagGlzVis, propDefaultTrue),
							},
						},
					},
				},
			},
		},
	},
} as const

const SheetConfigDict: UserConfigDefinitionType = {
	enabled: {
		label: 'Arbeitszeitmodell anzeigen',
		type: 'boolean',
		defaultValue: false,
		defaultOverrideSelector: selPropGen(PropID.stTagDefault, propDefaultFalse),
		visibleSelector: selPropGen(PropID.stTagVis, propDefaultTrue),
	},
}

let dict: UserConfigDefinitionType;
switch (appName) {
	case AppName.sheet:
		dict = SheetConfigDict
		break;
	default:
	case AppName.timeline:
	case AppName.timelineTask:
		dict = TimelineConfigDict
}

export const StTagZuUserConfigDict = dict